import { processCapturedImage } from 'Logic/ImageEditor.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useDataChange, useDataValue } from 'Simple/Data'
import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnChange(props) {
  let [, notify] = useNotifications()
  let slot_key = useDataValue({
    context: 'image',
    path: 'slot_key',
    viewPath: props.viewPath,
  })
  let settings = useDataValue({
    context: 'settings',
    path: slot_key,
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'image',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onChange(files) {
    if (!Array.isArray(files)) return
    let [src] = files
    if (!src) return

    setFlowTo(normalizePath(props.viewPath, 'Processing/Content'))
    let result = await processCapturedImage({ src, settings })
    setFlowTo(normalizePath(props.viewPath, 'Processing/No'))

    if (result.error) {
      return notify(notifyError(`Couldn't process the image.`))
    }

    change(next => {
      next.editor = null
      next.original_image = result.dest
      next.editor_src = result.dest
    })
  }
}
